// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-dropdown,
.p-multiselect,
.p-inputtext {
  background: #ffffff;
  height: 40px;
  width: 100%;
  transition:
    background-color 0.15s,
    border-color 0.15s,
    box-shadow 0.15s;
}

input.p-inputtext:not(.p-autocomplete-multiple-container):not(
    .p-inputnumber-input
  ),
textarea.p-inputtext:not(.p-autocomplete-multiple-container),
.p-dropdown,
.p-multiselect,
.p-autocomplete {
  border: 1px solid var(--branded-light-purple);
  border-radius: 6px;
}

.p-inputtext {
  font-size: 0.89rem;
  color: #495057;
  padding: 0.5rem 0.75rem;
}

.p-inputtext::placeholder {
  color: #999999 !important;
}

.p-button.p-button-secondary:not(:disabled):focus,
.p-button-group.p-button-secondary > .p-button:not(:disabled):focus,
.p-splitbutton.p-button-secondary > .p-button:not(:disabled):focus,
.p-fileupload-choose.p-button-secondary:not(:disabled):focus {
  box-shadow: none;
}

.p-dropdown-label,
.p-dropdown .p-dropdown-label {
  background: transparent;
  border: none;
  font-size: 0.89rem;
  align-self: center;
  display: flex;
  align-items: center;
}

.p-dropdown-label.p-placeholder {
  color: #999999 !important;
}

.p-dropdown-panel .p-dropdown-item-label {
  font-size: 0.89rem;
}

.p-dropdown-items {
  .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
    color: var(--branded-font-color);
    background: var(--branded-light-purple);
  }
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
  background: white !important;
  color: #495057 !important;
}

.p-dropdown-items-wrapper {
  border-radius: 6px;
  border: 1px solid var(--branded-light-purple);
}

.p-dropdown-item:focus-visible {
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  outline: none !important;
  -webkit-box-shadow: none !important;
  --tw-shadow: none !important;
}

.p-dropdown-items-wrapper {
  border-top: none;
}

.p-dropdown-item {
  border-top: none;
}

.p-tooltip {
  z-index: 10000 !important;
}

.p-tooltip-text {
  background-color: var(--branded-purple) !important;
  max-width: 300px;
}

.pi-times {
  position: relative;
  cursor: pointer;
}

.p-autocomplete-items-wrapper {
  border: 1px solid var(--branded-light-purple);

  .p-autocomplete-item:hover {
    color: var(--branded-font-color);
    background: var(--branded-light-purple);
  }
}

.p-autocomplete-token {
  background-color: rgba(135, 60, 170, 0.1);
  border-radius: 16px;
  padding: 3px 10.5px;
  font-size: 14px;
  color: #4b5563;
  font-weight: 400;
  display: inline-flex;
  /* Ensures width adapts to content */
  align-items: center;
  justify-content: center;
  max-width: max-content;
  /* Avoid full width */
  white-space: nowrap;
  /* Prevents text from wrapping */
  margin-right: 10px;
  margin-bottom: 10px;
}

.p-autocomplete-token-icon {
  background-color: transparent;
  color: #4b5563;
  border: none !important;
  padding: 0px;
}

.p-autocomplete-token-icon:focus {
  box-shadow: none !important;
}

.p-button {
  font-size: 1rem;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  background-color: var(--branded-purple);
  border: 1px solid var(--branded-purple) !important;
  color: white;
}

.p-inputnumber-button {
  padding: 0px !important;
}

.p-inputnumber-button-up {
  border-top-left-radius: 0px;
  border-top-right-radius: 6px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}

.p-inputnumber-button-up:hover {
  background-color: #a156db !important;
}

.p-inputnumber-button-down {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 6px;
}

.p-inputnumber-button-down:hover {
  background-color: #a156db !important;
}

.p-autocomplete-dropdown {
  background: transparent;
  color: #495057;
  border: none !important;

  .p-icon {
    width: 0.79rem;
    height: 0.79rem;
  }
}

.p-button.p-button-rounded {
  border-radius: 2rem;
}

.p-button.p-button-secondary {
  background-color: #ffffff !important;
  color: var(--branded-purple) !important;
  border: 1px solid var(--branded-purple) !important;
}

.p-button.p-button-secondary.p-disabled {
  background-color: #cccccc !important;
  color: #666666 !important;
  border: 1px solid var(--branded-purple) !important;
}

.p-button.p-button-secondary.p-button-text,
.p-button-group.p-button-secondary > .p-button.p-button-text,
.p-splitbutton.p-button-secondary > .p-button.p-button-text,
.p-fileupload-choose.p-button-secondary.p-button-text {
  background-color: transparent !important;
  color: var(--branded-purple) !important;
  border-color: transparent !important;
}

.p-button-text.p-button-secondary.p-disabled {
  color: #666666 !important;
}

.p-button-group .p-button {
  margin: 0;
  transition:
    background-color 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
}

.p-button-group .p-button:first-of-type {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.p-button-group .p-button:last-of-type {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.p-button-group .p-button:not(:first-of-type):not(:last-of-type) {
  border-radius: 0;
}

.p-selectbutton .p-button {
  background: #ffffff;
  border: 1px solid var(--branded-light-gray);
  color: var(--branded-font-color);
  height: 42px;
  min-width: 52px;
}

.p-selectbutton .p-button.p-highlight {
  background: var(--branded-purple);
  border-color: var(--branded-light-gray);
  color: #ffffff;
}

.p-selectbutton .p-button .p-button-label {
  font-size: 0.89rem;
}

.p-tabview {
  background: transparent;
}

.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  background: #ffffff;
  border-bottom: 3px solid #873caa;
  color: #873caa;
  font-weight: 700;
  font-size: 16px;
  line-height: 21.79px;
}

.p-calendar,
.p-password,
.p-inputnumber {
  width: 100%;
  border: 1px solid var(--branded-light-purple) !important;
  border-radius: 5px !important;
}

.p-password .p-password-input {
  border: none !important;
}

.p-checkbox .p-checkbox-box,
.p-radiobutton .p-radiobutton-box {
  border: 2px solid var(--branded-light-purple);
  background: #ffffff;
  width: 20px;
  height: 20px;
  color: var(--branded-font-color);
  border-radius: 6px;
  transition:
    background-color 0.15s,
    border-color 0.15s,
    box-shadow 0.15s;
}

.p-checkbox.p-highlight .p-checkbox-box,
.p-radiobutton.p-highlight .p-radiobutton-box {
  border-color: var(--branded-purple);
  background: var(--branded-purple);
}

.p-radiobutton .p-radiobutton-box {
  border-radius: 50%;
}

.p-datepicker {
  border: 1px solid var(--branded-purple-border) !important;
  border-radius: 10px !important;
}

.p-datepicker-title {
  background-color: var(--branded-purple);
  color: white;
  padding: 5px 20px;
  border-radius: 20px;
}

.p-datepicker-month {
  margin-right: 5px;
  color: var(--branded-font-color);
}

.p-icon-field {
  width: 100% !important;
}

.p-image-mask {
  border-radius: 10px !important;
  top: 10% !important;
  left: 10% !important;
  width: 80% !important;
  height: 80% !important;
  background-color: rgb(34 39 42/0.9) !important;
}

.p-image-preview {
  max-width: 60vw !important;
  max-height: 60vh !important;
  border-radius: 10px !important;
}

.p-image-preview-toolbar .p-image-preview-button-group {
  display: none;
}

.p-image-toolbar {
  gap: 10px;
}

.p-image-toolbar .p-image-action:nth-of-type(3),
.p-image-toolbar .p-image-action:nth-of-type(4) {
  display: none !important;
}

.p-image-action.p-link {
  width: 24px !important;
  height: 24px !important;
}

.p-image-action.p-link i {
  font-size: 24px !important;
}

.top-menu-label {
  color: white !important;
}

.p-accordion {
  display: flex;
  flex-direction: column;
  gap: 6px;

  .p-accordion-header:not(.p-disabled) .p-accordion-header-link {
    background: #eedef6;
    border-color: #eedef6;
    color: #383838;
    border-radius: 8px;
    font-size: 16px;
    font-weight: bold;
    border-radius: 10px;
  }

  .p-accordion-header:not(.p-disabled) a {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    height: 77px;
    padding: 16px;
  }

  .p-accordion-header-text {
    order: 1;
  }

  .p-accordion-toggle-icon {
    color: #873caa;
    order: 2;
    margin-left: auto;
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .p-accordion-content {
    padding: 1rem;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
  }
}

.p-accordion-tab-active {
  border: 1px solid var(--branded-purple-border);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}

.p-paginator .p-dropdown {
  margin-top: 0;
  width: fit-content;
}

.p-paginator {
  border: 1px solid var(--branded-purple-border);
  border-radius: 12px;
  background-color: var(--branded-extra-light-purple);
}

.p-paginator .p-paginator-first,
.p-paginator .p-paginator-prev,
.p-paginator .p-paginator-next,
.p-paginator .p-paginator-last {
  background-color: var(--branded-extra-light-purple);
  color: var(--branded-purple);
  height: 1.5rem;
  min-width: 1.5rem;
  margin: 0 0 0 -1px;
  transition: box-shadow 0.15s;
}

.p-paginator .p-paginator-page {
  font-size: 12px;
  height: 1.5rem;
  min-width: 1.5rem;
  color: black;
}

.p-paginator .p-highlight {
  background-color: #debeed80;
  border-radius: 50%;
}

.p-paginator .p-paginator-element {
  margin-right: 0.5rem;
}

.p-tag-error {
  background-color: #ffe7e6;
  color: #ff5757;
  font-weight: normal !important;
}

.p-tag-info {
  background-color: #debeed80;
  color: #4b5563;
  border-radius: 6px;
  height: 22px;
  font-size: 10px;
  font-weight: 600;
}

.p-multiselect-items-wrapper {
  background-color: white;
  border: solid #e7e0f1 1px;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

/* [START] <ConfirmDialog/> footer and buttons */
.p-dialog-footer {
  display: flex;
  flex-direction: row-reverse;
  justify-content: end;
  gap: 10px;
}

.p-confirm-dialog-accept {
  padding-left: 20px;
  padding-right: 20px;
}

.p-confirm-dialog-reject {
  background-color: white;
  color: var(--branded-action-purple);
  padding-left: 20px;
  padding-right: 20px;
}
/* [END] <ConfirmDialog/> footer and buttons */

.p-card-body {
  padding: 0rem 2rem !important;
}

.p-panel-header {
  background-color: #eedef6;
  border-radius: 10px;
}

.p-panel-toggleable {
  border: 1px solid var(--branded-purple-border);
  border-radius: 10px;
}

.p-panel-content {
  border-radius: 10px;
}

@media (max-width: 768px) {
  .p-multiselect-items-wrapper span {
    width: 100% !important;
  }
}

.p-multiselect-items-wrapper span {
  width: 100% !important;
}

.p-multiselect-panel
  .p-multiselect-items
  .p-multiselect-item:not(.p-highlight):not(.p-disabled).p-focus {
  background-color: white !important;
}

.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {
  color: #495057;
}

.p-multiselect-panel .p-multiselect-header {
  padding: 0.5rem 0.6rem;
}

.p-multiselect-panel:not(:has(.p-multiselect-header))
  .p-multiselect-items-wrapper {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.p-multiselect-filter.p-inputtext {
  height: 36px;
}

.p-multiselect-items {
  padding: 0.5rem;
}

.p-multiselect-item {
  min-height: 32px;
  padding: 0 0 0.5rem 0;
  font-size: 0.89rem;
}

.p-multiselect-item:last-child {
  padding-bottom: 0;
}

.p-multiselect-checkbox {
  display: flex;
}

.p-button.p-button-sort {
  padding: 0;
  width: 55px;
  height: 30px;
  border: solid #e7e0f1 1px !important;
  background-color: transparent;
}

.p-button.p-button-sort .p-button {
  border-radius: 4px;
  font-weight: 400;
  font-size: 10px;
  height: 100%;
  background-color: white;
  color: #495057;
  border: none !important;
}

.p-multiselect-trigger-icon,
.p-multiselect-clear-icon,
.p-dropdown-trigger-icon {
  width: 13px;
  height: 13px;
  color: #6b7280;
}

.p-multiselect-clear-icon {
  right: 2rem !important;
  width: 11px;
  height: 11px;
}

.p-button.p-button-sort.p-button-sort-enabled .p-button {
  background-color: #f3eff8;
  color: #873caa;
}

.p-button.p-button-sort.p-button-sort-active {
  color: #873caa;
  background-color: #f3eff8 !important;
  border: none !important;
}

.p-multiselect-token {
  background-color: rgba(135, 60, 170, 0.1);
  padding: 5.25px 10.5px 5.25px 10.5px;
  color: #4b5563;
  font-size: 14px;
  line-height: 16.94px;
  font-weight: 400;
}

.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {
  background-color: transparent;
}

.p-datepicker-trigger .p-button .p-component .p-accordion-content {
  background-color: red;
}

.custom_calendar_panel {
  border: 1px solid #873caa !important;
  border-radius: 8px 8px 0px 0px !important;
  font-size: 13px !important;
  color: #333 !important;
  min-width: auto !important;
}

.custom_calendar_panel .p-datepicker-calendar {
  color: #333 !important;
  font-size: 13px !important;
}

.custom_calendar_panel button {
  color: #873caa !important;
}

.custom_calendar_panel .p-datepicker-group-container {
  width: 255px !important;
}

.custom_calendar_panel table td > span {
  width: 18px !important;
  height: 18px !important;
}

.custom_calendar_panel .p-datepicker-header {
  height: 36px !important;
  background: rgba(231, 224, 241, 0.5) !important;
}

.custom_calendar_panel .p-timepicker {
  width: 210px !important;
}

.custom_calendar_panel .p-timepicker span {
  font-size: 13px !important;
}

.custom_calendar_panel .p-datepicker-buttonbar {
  padding: 0 !important;
}

.custom_calendar_panel .p-datepicker-buttonbar button {
  font-size: 0.9rem !important;
}

.top-icon {
  min-width: 45px !important;
}

.p-tabview .p-tabview-nav li .p-tabview-nav-link {
  border: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 21.79px;
}

.p-breadcrumb .p-breadcrumb-list li.p-menuitem-separator {
  color: #873caa !important;
}

.p-tabview .p-tabview-panels {
  padding-left: 0px;
  padding-right: 0px;
}

.p-tabview .p-tabview-nav li .p-tabview-nav-link {
  padding: 0.75rem 0.5rem;
  padding-left: 0.1rem;
  color: #888888;
  font-size: 16px;
  font-weight: 400;
  line-height: 21.79px;
}

.p-tabview-nav {
  gap: 2rem;
}

.ql-container.ql-snow {
  border: none !important;
}

.p-inputtextarea {
  resize: none !important;
}

.p-rating .p-rating-item .p-rating-icon.p-icon {
  width: 2rem;
  height: 2rem;
}

.p-rating {
  gap: 0.75rem;
}

.p-rating .p-rating-item.p-focus {
  box-shadow: none;
}

.p-rating .p-rating-item .p-rating-icon {
  color: #e7e0f1 !important;
}

.p-rating .p-rating-item.p-rating-item-active .p-rating-icon {
  color: #873caa !important;
}

.p-button:focus {
  box-shadow: none;
}

.p-inputwrapper-focus {
  box-shadow: none;
}

.p-disabled,
.p-component:disabled {
  opacity: unset !important;
}

.ql-editor {
  padding-top: 0.5rem !important;
  padding-left: 0.7rem !important;
  font-size: 12px;
  font-weight: 400;
  color: #495057;
  font-family: var(--font-family);
}

.top-icon-span {
  transition: none !important;
  width: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/rewrites.css"],"names":[],"mappings":"AAAA;;;EAGE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX;;;oBAGkB;AACpB;;AAEA;;;;;;;EAOE,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,gCAAgC;IAChC,uCAAuC;EACzC;AACF;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6CAA6C;;EAE7C;IACE,gCAAgC;IAChC,uCAAuC;EACzC;AACF;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,uCAAuC;EACvC,kDAAkD;EAClD,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,uBAAuB;;EAEvB;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,kDAAkD;AACpD;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,kDAAkD;AACpD;;AAEA;;;;EAIE,wCAAwC;EACxC,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT;;;mBAGiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,gCAAgC;EAChC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;EAGE,WAAW;EACX,wDAAwD;EACxD,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,6CAA6C;EAC7C,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB;;;oBAGkB;AACpB;;AAEA;;EAEE,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yDAAyD;EACzD,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;;EAER;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,QAAQ;IACR,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,gCAAgC;IAChC,+BAA+B;EACjC;AACF;;AAEA;EACE,8CAA8C;EAC9C,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;;;;EAIE,mDAAmD;EACnD,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,2BAA2B;EAC3B,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;AACrB;AACA,8CAA8C;;AAE9C;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,uBAAuB;AACzB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,0BAA0B;EAC1B,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB","sourcesContent":[".p-dropdown,\n.p-multiselect,\n.p-inputtext {\n  background: #ffffff;\n  height: 40px;\n  width: 100%;\n  transition:\n    background-color 0.15s,\n    border-color 0.15s,\n    box-shadow 0.15s;\n}\n\ninput.p-inputtext:not(.p-autocomplete-multiple-container):not(\n    .p-inputnumber-input\n  ),\ntextarea.p-inputtext:not(.p-autocomplete-multiple-container),\n.p-dropdown,\n.p-multiselect,\n.p-autocomplete {\n  border: 1px solid var(--branded-light-purple);\n  border-radius: 6px;\n}\n\n.p-inputtext {\n  font-size: 0.89rem;\n  color: #495057;\n  padding: 0.5rem 0.75rem;\n}\n\n.p-inputtext::placeholder {\n  color: #999999 !important;\n}\n\n.p-button.p-button-secondary:not(:disabled):focus,\n.p-button-group.p-button-secondary > .p-button:not(:disabled):focus,\n.p-splitbutton.p-button-secondary > .p-button:not(:disabled):focus,\n.p-fileupload-choose.p-button-secondary:not(:disabled):focus {\n  box-shadow: none;\n}\n\n.p-dropdown-label,\n.p-dropdown .p-dropdown-label {\n  background: transparent;\n  border: none;\n  font-size: 0.89rem;\n  align-self: center;\n  display: flex;\n  align-items: center;\n}\n\n.p-dropdown-label.p-placeholder {\n  color: #999999 !important;\n}\n\n.p-dropdown-panel .p-dropdown-item-label {\n  font-size: 0.89rem;\n}\n\n.p-dropdown-items {\n  .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {\n    color: var(--branded-font-color);\n    background: var(--branded-light-purple);\n  }\n}\n\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {\n  background: white !important;\n  color: #495057 !important;\n}\n\n.p-dropdown-items-wrapper {\n  border-radius: 6px;\n  border: 1px solid var(--branded-light-purple);\n}\n\n.p-dropdown-item:focus-visible {\n  border: none !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  outline: none !important;\n  -webkit-box-shadow: none !important;\n  --tw-shadow: none !important;\n}\n\n.p-dropdown-items-wrapper {\n  border-top: none;\n}\n\n.p-dropdown-item {\n  border-top: none;\n}\n\n.p-tooltip {\n  z-index: 10000 !important;\n}\n\n.p-tooltip-text {\n  background-color: var(--branded-purple) !important;\n  max-width: 300px;\n}\n\n.pi-times {\n  position: relative;\n  cursor: pointer;\n}\n\n.p-autocomplete-items-wrapper {\n  border: 1px solid var(--branded-light-purple);\n\n  .p-autocomplete-item:hover {\n    color: var(--branded-font-color);\n    background: var(--branded-light-purple);\n  }\n}\n\n.p-autocomplete-token {\n  background-color: rgba(135, 60, 170, 0.1);\n  border-radius: 16px;\n  padding: 3px 10.5px;\n  font-size: 14px;\n  color: #4b5563;\n  font-weight: 400;\n  display: inline-flex;\n  /* Ensures width adapts to content */\n  align-items: center;\n  justify-content: center;\n  max-width: max-content;\n  /* Avoid full width */\n  white-space: nowrap;\n  /* Prevents text from wrapping */\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n\n.p-autocomplete-token-icon {\n  background-color: transparent;\n  color: #4b5563;\n  border: none !important;\n  padding: 0px;\n}\n\n.p-autocomplete-token-icon:focus {\n  box-shadow: none !important;\n}\n\n.p-button {\n  font-size: 1rem;\n  padding: 0.5rem 0.75rem;\n  border-radius: 6px;\n  background-color: var(--branded-purple);\n  border: 1px solid var(--branded-purple) !important;\n  color: white;\n}\n\n.p-inputnumber-button {\n  padding: 0px !important;\n}\n\n.p-inputnumber-button-up {\n  border-top-left-radius: 0px;\n  border-top-right-radius: 6px;\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n}\n\n.p-inputnumber-button-up:hover {\n  background-color: #a156db !important;\n}\n\n.p-inputnumber-button-down {\n  border-top-left-radius: 0px;\n  border-top-right-radius: 0px;\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 6px;\n}\n\n.p-inputnumber-button-down:hover {\n  background-color: #a156db !important;\n}\n\n.p-autocomplete-dropdown {\n  background: transparent;\n  color: #495057;\n  border: none !important;\n\n  .p-icon {\n    width: 0.79rem;\n    height: 0.79rem;\n  }\n}\n\n.p-button.p-button-rounded {\n  border-radius: 2rem;\n}\n\n.p-button.p-button-secondary {\n  background-color: #ffffff !important;\n  color: var(--branded-purple) !important;\n  border: 1px solid var(--branded-purple) !important;\n}\n\n.p-button.p-button-secondary.p-disabled {\n  background-color: #cccccc !important;\n  color: #666666 !important;\n  border: 1px solid var(--branded-purple) !important;\n}\n\n.p-button.p-button-secondary.p-button-text,\n.p-button-group.p-button-secondary > .p-button.p-button-text,\n.p-splitbutton.p-button-secondary > .p-button.p-button-text,\n.p-fileupload-choose.p-button-secondary.p-button-text {\n  background-color: transparent !important;\n  color: var(--branded-purple) !important;\n  border-color: transparent !important;\n}\n\n.p-button-text.p-button-secondary.p-disabled {\n  color: #666666 !important;\n}\n\n.p-button-group .p-button {\n  margin: 0;\n  transition:\n    background-color 0.2s,\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.p-button-group .p-button:first-of-type {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.p-button-group .p-button:last-of-type {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.p-button-group .p-button:not(:first-of-type):not(:last-of-type) {\n  border-radius: 0;\n}\n\n.p-selectbutton .p-button {\n  background: #ffffff;\n  border: 1px solid var(--branded-light-gray);\n  color: var(--branded-font-color);\n  height: 42px;\n  min-width: 52px;\n}\n\n.p-selectbutton .p-button.p-highlight {\n  background: var(--branded-purple);\n  border-color: var(--branded-light-gray);\n  color: #ffffff;\n}\n\n.p-selectbutton .p-button .p-button-label {\n  font-size: 0.89rem;\n}\n\n.p-tabview {\n  background: transparent;\n}\n\n.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {\n  background: #ffffff;\n  border-bottom: 3px solid #873caa;\n  color: #873caa;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 21.79px;\n}\n\n.p-calendar,\n.p-password,\n.p-inputnumber {\n  width: 100%;\n  border: 1px solid var(--branded-light-purple) !important;\n  border-radius: 5px !important;\n}\n\n.p-password .p-password-input {\n  border: none !important;\n}\n\n.p-checkbox .p-checkbox-box,\n.p-radiobutton .p-radiobutton-box {\n  border: 2px solid var(--branded-light-purple);\n  background: #ffffff;\n  width: 20px;\n  height: 20px;\n  color: var(--branded-font-color);\n  border-radius: 6px;\n  transition:\n    background-color 0.15s,\n    border-color 0.15s,\n    box-shadow 0.15s;\n}\n\n.p-checkbox.p-highlight .p-checkbox-box,\n.p-radiobutton.p-highlight .p-radiobutton-box {\n  border-color: var(--branded-purple);\n  background: var(--branded-purple);\n}\n\n.p-radiobutton .p-radiobutton-box {\n  border-radius: 50%;\n}\n\n.p-datepicker {\n  border: 1px solid var(--branded-purple-border) !important;\n  border-radius: 10px !important;\n}\n\n.p-datepicker-title {\n  background-color: var(--branded-purple);\n  color: white;\n  padding: 5px 20px;\n  border-radius: 20px;\n}\n\n.p-datepicker-month {\n  margin-right: 5px;\n  color: var(--branded-font-color);\n}\n\n.p-icon-field {\n  width: 100% !important;\n}\n\n.p-image-mask {\n  border-radius: 10px !important;\n  top: 10% !important;\n  left: 10% !important;\n  width: 80% !important;\n  height: 80% !important;\n  background-color: rgb(34 39 42/0.9) !important;\n}\n\n.p-image-preview {\n  max-width: 60vw !important;\n  max-height: 60vh !important;\n  border-radius: 10px !important;\n}\n\n.p-image-preview-toolbar .p-image-preview-button-group {\n  display: none;\n}\n\n.p-image-toolbar {\n  gap: 10px;\n}\n\n.p-image-toolbar .p-image-action:nth-of-type(3),\n.p-image-toolbar .p-image-action:nth-of-type(4) {\n  display: none !important;\n}\n\n.p-image-action.p-link {\n  width: 24px !important;\n  height: 24px !important;\n}\n\n.p-image-action.p-link i {\n  font-size: 24px !important;\n}\n\n.top-menu-label {\n  color: white !important;\n}\n\n.p-accordion {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n\n  .p-accordion-header:not(.p-disabled) .p-accordion-header-link {\n    background: #eedef6;\n    border-color: #eedef6;\n    color: #383838;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: bold;\n    border-radius: 10px;\n  }\n\n  .p-accordion-header:not(.p-disabled) a {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n    height: 77px;\n    padding: 16px;\n  }\n\n  .p-accordion-header-text {\n    order: 1;\n  }\n\n  .p-accordion-toggle-icon {\n    color: #873caa;\n    order: 2;\n    margin-left: auto;\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .p-accordion-content {\n    padding: 1rem;\n    border-bottom-right-radius: 10px;\n    border-bottom-left-radius: 10px;\n  }\n}\n\n.p-accordion-tab-active {\n  border: 1px solid var(--branded-purple-border);\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  border-bottom-right-radius: 10px;\n  border-bottom-left-radius: 10px;\n}\n\n.p-paginator .p-dropdown {\n  margin-top: 0;\n  width: fit-content;\n}\n\n.p-paginator {\n  border: 1px solid var(--branded-purple-border);\n  border-radius: 12px;\n  background-color: var(--branded-extra-light-purple);\n}\n\n.p-paginator .p-paginator-first,\n.p-paginator .p-paginator-prev,\n.p-paginator .p-paginator-next,\n.p-paginator .p-paginator-last {\n  background-color: var(--branded-extra-light-purple);\n  color: var(--branded-purple);\n  height: 1.5rem;\n  min-width: 1.5rem;\n  margin: 0 0 0 -1px;\n  transition: box-shadow 0.15s;\n}\n\n.p-paginator .p-paginator-page {\n  font-size: 12px;\n  height: 1.5rem;\n  min-width: 1.5rem;\n  color: black;\n}\n\n.p-paginator .p-highlight {\n  background-color: #debeed80;\n  border-radius: 50%;\n}\n\n.p-paginator .p-paginator-element {\n  margin-right: 0.5rem;\n}\n\n.p-tag-error {\n  background-color: #ffe7e6;\n  color: #ff5757;\n  font-weight: normal !important;\n}\n\n.p-tag-info {\n  background-color: #debeed80;\n  color: #4b5563;\n  border-radius: 6px;\n  height: 22px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.p-multiselect-items-wrapper {\n  background-color: white;\n  border: solid #e7e0f1 1px;\n  border-bottom-right-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n/* [START] <ConfirmDialog/> footer and buttons */\n.p-dialog-footer {\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: end;\n  gap: 10px;\n}\n\n.p-confirm-dialog-accept {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.p-confirm-dialog-reject {\n  background-color: white;\n  color: var(--branded-action-purple);\n  padding-left: 20px;\n  padding-right: 20px;\n}\n/* [END] <ConfirmDialog/> footer and buttons */\n\n.p-card-body {\n  padding: 0rem 2rem !important;\n}\n\n.p-panel-header {\n  background-color: #eedef6;\n  border-radius: 10px;\n}\n\n.p-panel-toggleable {\n  border: 1px solid var(--branded-purple-border);\n  border-radius: 10px;\n}\n\n.p-panel-content {\n  border-radius: 10px;\n}\n\n@media (max-width: 768px) {\n  .p-multiselect-items-wrapper span {\n    width: 100% !important;\n  }\n}\n\n.p-multiselect-items-wrapper span {\n  width: 100% !important;\n}\n\n.p-multiselect-panel\n  .p-multiselect-items\n  .p-multiselect-item:not(.p-highlight):not(.p-disabled).p-focus {\n  background-color: white !important;\n}\n\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {\n  color: #495057;\n}\n\n.p-multiselect-panel .p-multiselect-header {\n  padding: 0.5rem 0.6rem;\n}\n\n.p-multiselect-panel:not(:has(.p-multiselect-header))\n  .p-multiselect-items-wrapper {\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n}\n\n.p-multiselect-filter.p-inputtext {\n  height: 36px;\n}\n\n.p-multiselect-items {\n  padding: 0.5rem;\n}\n\n.p-multiselect-item {\n  min-height: 32px;\n  padding: 0 0 0.5rem 0;\n  font-size: 0.89rem;\n}\n\n.p-multiselect-item:last-child {\n  padding-bottom: 0;\n}\n\n.p-multiselect-checkbox {\n  display: flex;\n}\n\n.p-button.p-button-sort {\n  padding: 0;\n  width: 55px;\n  height: 30px;\n  border: solid #e7e0f1 1px !important;\n  background-color: transparent;\n}\n\n.p-button.p-button-sort .p-button {\n  border-radius: 4px;\n  font-weight: 400;\n  font-size: 10px;\n  height: 100%;\n  background-color: white;\n  color: #495057;\n  border: none !important;\n}\n\n.p-multiselect-trigger-icon,\n.p-multiselect-clear-icon,\n.p-dropdown-trigger-icon {\n  width: 13px;\n  height: 13px;\n  color: #6b7280;\n}\n\n.p-multiselect-clear-icon {\n  right: 2rem !important;\n  width: 11px;\n  height: 11px;\n}\n\n.p-button.p-button-sort.p-button-sort-enabled .p-button {\n  background-color: #f3eff8;\n  color: #873caa;\n}\n\n.p-button.p-button-sort.p-button-sort-active {\n  color: #873caa;\n  background-color: #f3eff8 !important;\n  border: none !important;\n}\n\n.p-multiselect-token {\n  background-color: rgba(135, 60, 170, 0.1);\n  padding: 5.25px 10.5px 5.25px 10.5px;\n  color: #4b5563;\n  font-size: 14px;\n  line-height: 16.94px;\n  font-weight: 400;\n}\n\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {\n  background-color: transparent;\n}\n\n.p-datepicker-trigger .p-button .p-component .p-accordion-content {\n  background-color: red;\n}\n\n.custom_calendar_panel {\n  border: 1px solid #873caa !important;\n  border-radius: 8px 8px 0px 0px !important;\n  font-size: 13px !important;\n  color: #333 !important;\n  min-width: auto !important;\n}\n\n.custom_calendar_panel .p-datepicker-calendar {\n  color: #333 !important;\n  font-size: 13px !important;\n}\n\n.custom_calendar_panel button {\n  color: #873caa !important;\n}\n\n.custom_calendar_panel .p-datepicker-group-container {\n  width: 255px !important;\n}\n\n.custom_calendar_panel table td > span {\n  width: 18px !important;\n  height: 18px !important;\n}\n\n.custom_calendar_panel .p-datepicker-header {\n  height: 36px !important;\n  background: rgba(231, 224, 241, 0.5) !important;\n}\n\n.custom_calendar_panel .p-timepicker {\n  width: 210px !important;\n}\n\n.custom_calendar_panel .p-timepicker span {\n  font-size: 13px !important;\n}\n\n.custom_calendar_panel .p-datepicker-buttonbar {\n  padding: 0 !important;\n}\n\n.custom_calendar_panel .p-datepicker-buttonbar button {\n  font-size: 0.9rem !important;\n}\n\n.top-icon {\n  min-width: 45px !important;\n}\n\n.p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  border: none;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 21.79px;\n}\n\n.p-breadcrumb .p-breadcrumb-list li.p-menuitem-separator {\n  color: #873caa !important;\n}\n\n.p-tabview .p-tabview-panels {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n.p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  padding: 0.75rem 0.5rem;\n  padding-left: 0.1rem;\n  color: #888888;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 21.79px;\n}\n\n.p-tabview-nav {\n  gap: 2rem;\n}\n\n.ql-container.ql-snow {\n  border: none !important;\n}\n\n.p-inputtextarea {\n  resize: none !important;\n}\n\n.p-rating .p-rating-item .p-rating-icon.p-icon {\n  width: 2rem;\n  height: 2rem;\n}\n\n.p-rating {\n  gap: 0.75rem;\n}\n\n.p-rating .p-rating-item.p-focus {\n  box-shadow: none;\n}\n\n.p-rating .p-rating-item .p-rating-icon {\n  color: #e7e0f1 !important;\n}\n\n.p-rating .p-rating-item.p-rating-item-active .p-rating-icon {\n  color: #873caa !important;\n}\n\n.p-button:focus {\n  box-shadow: none;\n}\n\n.p-inputwrapper-focus {\n  box-shadow: none;\n}\n\n.p-disabled,\n.p-component:disabled {\n  opacity: unset !important;\n}\n\n.ql-editor {\n  padding-top: 0.5rem !important;\n  padding-left: 0.7rem !important;\n  font-size: 12px;\n  font-weight: 400;\n  color: #495057;\n  font-family: var(--font-family);\n}\n\n.top-icon-span {\n  transition: none !important;\n  width: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
